import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import Storage from "@bd-utils/storage";
import BD_Component from "../core/bd-component";
import compile from "../utils/handlerbars-helper";
import CONFIG from "@bd-core/config";
import { getState } from "@bd-stores/store";
import { copyObject } from "@bd-utils/copyObject";
import { getRoomAnswerById } from "@bd-stores/game-data";
import { getPrettyMatrixData } from "@bd-utils/getPrettyMatrixData";
import { getRoomStatus, getFinalTeamAnswers } from "@bd-stores/game-progress";
import CompletionPopup from "@bd-utils/completion-popup";
import {
    saveFinalRoomAnswers,
    maybeUpdateRoomStatus,
    updateRoomAnswer,
    getRoomAnswers,
} from "@bd-core/firebase-actions";

export class RoomMatrixChallenge extends BD_Component {
    constructor() {
        super();

        this.id = "matrix_challenge";
        this.templateID = "matrix_challenge-template";

        this.elms = {
            row: ".js-row",
            inputAnswer: ".js-input-answer",
            checkAnswer: ".js-check",
            check: ".js-matrix",
            resultCorrect: ".js-correct",
            resultMiddle: ".js-middle",
            resultIncorrect: ".js-incorrect",
        };

        this._events = this.getEvents();

        this._data = {};

        this._questions = [];

        this._labels = [];

        this.completionPopup = new CompletionPopup();
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "input",
                selector: elms.inputAnswer,
                handler: this.inputAnswer,
            },
            {
                event: "click",
                selector: elms.checkAnswer,
                handler: this.checkAnswer,
            },
        ];
    }

    beforeInit() {
        const data = this._data;
        const { questions, labels } = getPrettyMatrixData(data.answers);
        this._questions = questions;
        this._labels = labels;

        this.render();
        this.setGameState();
    }

    getModifiedData() {
        const modified = { ...this._data };

        const defaultImageBg = `${CONFIG.themeURL}/assets/images/bg-wood.png`;

        const _image_bg = this._data.image_bg
            ? this._data.image_bg
            : defaultImageBg;

        const hintHotspots = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "hint",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";

        const _hints = this._data.hints.map((hint, i) => {
            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const _hotspots = this._data.hotspots
            .filter((h) => h["hotspot_type"] === "puzzle")
            .shift();

        const modifiedData = {
            ...modified,
            hints: _hints,
            hotspots: _hotspots,
            image_bg: _image_bg,
        };

        return modifiedData;
    }

    render() {
        const htmlTemplate = $("#" + this.templateID).html();
        const modifiedData = this.getModifiedData();

        const isForcedOpenChallenge = modifiedData["force_open_challenge"];

        const _modifiedData = copyObject(modifiedData);
        _modifiedData["answers"] = this._questions;
        _modifiedData["labels"] = this._labels;

        let template = compile(htmlTemplate, _modifiedData);

        $(".app").html(template);

        if (isForcedOpenChallenge) {
            this.onForceOppenChallenge();
        }
    }

    onForceOppenChallenge() {
        const elms = this.elms.questionPopup;
        const closeButton = this.elms.closeButtonPopup;
        const backButton = this.elms.backButton;

        const blur = $(".app-blur");

        blur.addClass("is-blurred");

        $(elms).addClass("is-open");
        $(closeButton).addClass("hidden");
        $(backButton).addClass("up-front");
    }

    setGameState() {
        const elms = this.elms;
        const roomID = this.roomId;
        const status = getRoomStatus(roomID);
        const roomAnswers = getFinalTeamAnswers(roomID);

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (status) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(status);
        }

        const $questionWrapper = $(".cyclePuzzleQuestion");

        const setAnswers = (answers) => {
            let answers_ = typeof answers === "string" ? [...answers] : answers;

            answers_ = bdjs.indexedObjectToArray(answers_);

            answers_.forEach((answerRow, i) => {
                this._labels.forEach((label) => {
                    const index = i + 2;
                    const row = `.cyclePuzzleQuestion__row:nth-child(${index})`;
                    const $el = $(`${row} [name="${label.name}"]`);
                    const column_id = $el.attr("data-column-id");
                    const isReadOnly = $el.is("[data-server-readonly]");

                    if (!isReadOnly) {
                        const visualValueWrap = $el.siblings(
                            ".inputVisual--value",
                        );

                        if (answerRow[column_id] !== "") {
                            visualValueWrap.text(answerRow[column_id]);
                            $el.val(answerRow[column_id]);
                            $el.addClass("valid");
                        }
                    }
                });
            });
        };

        if (roomAnswers && Object.keys(roomAnswers).length) {
            setAnswers(roomAnswers);
        } else {
            const localAnswers = this.getSavedAnswers();

            if (Object.keys(localAnswers).length) {
                setAnswers(localAnswers);
                this.toggleCheckButton();
            }
        }

        if (status == "is-status-completed") {
            $(`${elms.inputAnswer}:not([data-server-readonly])`)
                .prop("disabled", true)
                .addClass("is-checked is-completed");
            $(elms.checkAnswer).addClass("is-completed").prop("disabled", true);
            $(elms.check).addClass("is-completed");
            $questionWrapper.addClass("is-completed");
            $(".app__page").addClass("is-room-completed");

            /* Show completion popup */
            this.completionPopup.show(roomID, false, roomAnswers);
        }

        getRoomAnswers(roomID).then((data) => {
            this.updateUserChoicesList(data);
        });
    }

    // ============================== CUSTOM FUNCTION
    getUserAnswers() {
        const questions = this._questions;
        const labels = this._labels;

        // Total of column that is not an answer
        const unused = 1;
        let answerPerRow = [];

        const answers = questions.reduce((accumulator, question, i) => {
            // let newAccumulator = [...accumulator];
            let key = question.row_id;
            const answerPerCol = labels.reduce((answerPerColumns, label) => {
                const newAnswerPerColumns = { ...answerPerColumns };
                const index = i + unused + 1;
                const row = `.cyclePuzzleQuestion__row:nth-child(${index})`;

                const $el = $(`${row} [name="${label.name}"]`);
                const column_id = $el.attr("data-column-id");
                const isReadOnly = $el.is("[data-server-readonly]");

                if (!isReadOnly) newAnswerPerColumns[column_id] = $el.val();

                return newAnswerPerColumns;
            }, {});

            answerPerRow[key] = answerPerCol;
            // newAccumulator.push(answerPerCol);

            return answerPerRow;
        }, []);

        return answers;
    }

    checkAnswer(e, $el) {
        const elms = this.elms;

        if ($el.hasClass("is-loading") || $el.hasClass("is-completed")) return;

        $el.parent().removeClass("is-checked");
        $el.addClass("is-loading").prop("disabled", true);

        // All of the answers element except the prefilled one
        const $uncontrolledAnswers = $(
            `${elms.inputAnswer}:not([data-server-readonly])`,
        );

        $uncontrolledAnswers.prop("readonly", true);

        const roomID = this.roomId;
        let answerData = this.getUserAnswers();
        let roomAnswers = getRoomAnswerById(roomID);
        let roomStatus = "is-status-started";
        let correct = 0;
        let wrong = 0;

        $.each(roomAnswers, function (key, answers) {
            $.each(answers, function (index, answer) {
                if (answer == answerData[key][index]) {
                    correct++;
                } else {
                    wrong++;
                }
            });
        });

        const isAllCorrect = wrong === 0 && correct > 0;

        $(elms.check).addClass("is-checked");

        if (isAllCorrect) {
            roomStatus = "is-status-completed";
            answerData = Object.assign({}, answerData);

            const onSuccess = () => {
                $el.addClass("is-completed").prop("disabled", isAllCorrect);
                $(elms.check).addClass("is-completed");
            };

            const onError = () => {};

            saveFinalRoomAnswers(roomID, answerData)
                .then(onSuccess)
                .catch(onError);
        } else {
            $(elms.check).removeClass("is-wrong");
        }

        $(elms.resultCorrect).text(correct);
        $(elms.resultIncorrect).text(wrong);

        $uncontrolledAnswers.prop("readonly", isAllCorrect);
        $el.removeClass("is-loading").removeAttr("disabled");

        this.updateUserAnswer(Object.assign({}, answerData));

        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    getSavedAnswers() {
        const roomID = this.roomId;
        const states = Storage.get("states", {});
        const savedAnswers = states?.answers?.[roomID] || {};

        return savedAnswers;
    }

    setSavedAnswers(answers) {
        const roomID = this.roomId;
        let states = Storage.get("states", {});
        if (!states?.answers) states.answers = {};
        if (!states?.answers?.[roomID]) states.answers[roomID] = {};
        states.answers[roomID] = answers;

        return Storage.set("states", states);
    }

    /**
     * Save answer for particular questionId into local storage
     * @param {string} rowID
     * @param {string} columnID
     * @param {string} value
     */
    saveAnswer(rowID, columnID, value) {
        let savedAnswers = this.getSavedAnswers();
        savedAnswers[rowID] = {
            [columnID]: value,
        };

        this.setSavedAnswers(savedAnswers);
    }

    inputAnswer(e, el) {
        const elms = this.elms;
        const isCompleted = $(elms.checkAnswer).hasClass("is-completed");

        if (isCompleted) return false;

        const answer = String($(el).val());
        const isValid = answer.trim().length > 0;
        const visualValueWrap = $(el).siblings(".inputVisual--value");
        const rowID = $(el).parents(elms.row).attr("data-row-id");
        const columnID = $(el).attr("data-column-id");

        visualValueWrap.text(answer);

        $(el).toggleClass("valid", isValid);
        this.toggleCheckButton();

        if (isValid) this.saveAnswer(rowID, columnID, answer);
    }

    toggleCheckButton() {
        const elms = this.elms;
        const isCompleted = $(elms.check).hasClass("is-completed");

        if (isCompleted) return false;

        // Array of boolean that represent whether or not user has answer the
        // question
        const inputs = $(elms.inputAnswer)
            .map(function () {
                return String($(this).val()).trim();
            })
            .get();

        const completeAllInputs = inputs.every((input) => input.length > 0);

        $(elms.checkAnswer).prop("disabled", !completeAllInputs);
    }

    updateUserAnswer(answerData) {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        updateRoomAnswer(roomId, {
            [currentPlayerId]: {
                user_id: currentPlayerId,
                choice: answerData,
            },
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const $context = $(this).parents(".js-userChoices-context");
            const hasContext = $context.length > 0;

            const questionID = hasContext
                ? $context.attr("data-question-id")
                : undefined;
            const columnID = hasContext
                ? $context.attr("data-column-id")
                : undefined;

            const users = onlinePlayers.map((player) => {
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (
                    typeof thisPlayerAnswer !== "object" ||
                    typeof thisPlayerAnswer[questionID][columnID] == "undefined"
                ) {
                    return;
                }

                const answer = thisPlayerAnswer[questionID][columnID];

                if (typeof answer == "string") {
                    const user = {
                        ...player,
                        answer: answer,
                    };

                    return user;
                }
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }
}
